/*

  SunCorona.ts

  Solar corona display component for celebration animations in Gáta Dagsins

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjálmur Þorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { Component, m } from "./mithril";

interface ISunCoronaAttributes {
  animate?: boolean;
  size?: number; // Size in pixels, defaults to 80
}

export const SunCorona: Component<ISunCoronaAttributes> = {
  view: (vnode: any) => {
    const { animate = false, size = 80 } = vnode.attrs;
    // Calculate ray positions based on size
    // For 80px: rays from -40 to -20 (inner radius 20px, outer radius 40px)
    // For 90px: rays from -45 to -30 (inner radius 30px, outer radius 45px) to fit 60px circle
    const outerRadius = size / 2;
    const innerRadius = size / 3;

    return m("div.sun-corona" + (animate ? ".rotating" : ""), [
      m.trust(`
        <svg width="${size}" height="${size}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(50,50)">
            <!-- Ray at 0° (12 o'clock) -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(0)"/>
            <!-- Ray at 30° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(30)"/>
            <!-- Ray at 60° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(60)"/>
            <!-- Ray at 90° (3 o'clock) -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(90)"/>
            <!-- Ray at 120° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(120)"/>
            <!-- Ray at 150° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(150)"/>
            <!-- Ray at 180° (6 o'clock) -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(180)"/>
            <!-- Ray at 210° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(210)"/>
            <!-- Ray at 240° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(240)"/>
            <!-- Ray at 270° (9 o'clock) -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(270)"/>
            <!-- Ray at 300° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f1c40f" opacity="0.8" transform="rotate(300)"/>
            <!-- Ray at 330° -->
            <polygon points="0,-${outerRadius} -3,-${innerRadius} 3,-${innerRadius}" fill="#f39c12" opacity="0.7" transform="rotate(330)"/>
          </g>
        </svg>
      `)
    ]);
  }
};